import styled from "styled-components"

export const SiteWrapper = styled.div<{ isShow: boolean }>`
  display: ${props => (props.isShow ? "flex" : "none")};
  flex-direction: column;
  min-height: 100vh;
`
